/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {useEffect} from 'react';
import isEmpty from 'lodash.isempty';
import isEqual from 'lodash.isequal';
import {translate} from '@ion/core/src/locale/locale';
import {CTCEntity, GenericObject} from '@ion/core/src/types/entities';
import BulkSCISettings from '../pages/devices/BulkSCISettings';
import {
  ActiveStep,
  UseSCIUpdateSettingsResult
} from './hooks/useSCIUpdateSettings';
import BulkSCIUpdateDeviceType from './BulkSCIUpdateDeviceType';
import {SCIUpdateDetailsFields} from './SCIUpdateDetailsForm';

export interface BulkSCIUpdateProps extends UseSCIUpdateSettingsResult {
  selectedRowEntities?: CTCEntity[];
  setSelectedSCIDevices?: (selectedSCIDevices: []) => void;
  selectedSCIDevices?: Array<[]>;
  setSelectedSCITypes?: (selectedSCITypes: string[]) => void;
  selectedSCITypes?: string[];
  setSelectedDeviceType?: (selectedDeviceType: string) => void;
  selectedDeviceType?: string;
  entitySelectionFormState?: GenericObject;
  path?: string;
  classes?: {
    [key: string]: string;
  };
  handleSnackBar?: () => void;
  bulkImportParams?: GenericObject;
  errorMessage?: boolean;
}

export const BulkSCIUpdateDetails = ({
  selectedSCIDevices,
  selectedSCITypes,
  selectedDeviceType,
  selectedRowEntities,
  setUpdatedSCISettings,
  updatedSCISettings,
  setFormState,
  setBulkSCISetting,
  bulkSCISetting,
  activeStep,
  path,
  classes,
  typeOptions,
  onTypeChange,
  deviceTypes,
  errorMessage = false
}: BulkSCIUpdateProps) => {
  useEffect(() => {
    setFormState({
      [SCIUpdateDetailsFields.UPDATED_SCI_SETTINGS] : {
        name     : SCIUpdateDetailsFields.UPDATED_SCI_SETTINGS,
        required : true,
        value    : updatedSCISettings
      }
    });
  }, [updatedSCISettings]);

  return (
    <>
      <BulkSCIUpdateDeviceType classes={classes}
        selectedRowEntities={selectedRowEntities}
        selectedSCIDevices={selectedSCIDevices}
        selectedSCITypes={selectedSCITypes}
        path={path}
        typeOptions={typeOptions}
        onTypeChange={onTypeChange}
        deviceTypes={deviceTypes} />
      {errorMessage && (
        <span className={classes.errorMessage}>{translate('common:editors.shared.required')}</span>
      )}
      {isEqual(activeStep, ActiveStep.SECOND) && (
        <BulkSCISettings selectedDevicetype={selectedDeviceType}
          setChangedSettingFields={setUpdatedSCISettings}
          bulkSettingPersist={bulkSCISetting}
          setBulkSettingPersist={setBulkSCISetting}
          isBulkAction={true} />
      )}
    </>
  );
};

export default BulkSCIUpdateDetails;
